// extracted by mini-css-extract-plugin
module.exports = {"outerDiv":"ConfirmationThrow_outerDiv__1ydRH","img":"ConfirmationThrow_img__xJpRM","text":"ConfirmationThrow_text__1aFHC"};